import { Injectable } from "@angular/core";
import { CreateOrganisationRelationshipDto } from "../dto/create-organisation-relationship.dto";
import { Store } from "@ngrx/store";
import { RestService } from "../../../services/rest.service";
import { Organisation } from "../../organisation";
import { OrganisationRelationship } from "../model/organisation-relationship.model";
import { CollectionTemplate } from "../../collection-template";

@Injectable({
  providedIn: 'root'
})
export class OrganisationRelationshipMasterApiService {


  private static readonly ApiEndpoint = "master/organisation-relationship/";


  constructor(
    private restService: RestService
  ) {

  }


  create(dto: CreateOrganisationRelationshipDto) {
    return this.restService.send<OrganisationRelationship>({
      url: OrganisationRelationshipMasterApiService.ApiEndpoint,
      method: "POST",
      body: dto,
    });
  }

  getChildren(parentOrgId: string) {
    return this.restService.send<OrganisationRelationship[]>({
      url: OrganisationRelationshipMasterApiService.ApiEndpoint + 'children',
      method: "GET",
      query: {
        parentOrgId: parentOrgId
      }
    })
  }


}
